import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useDescriptionFooters } from '../../hooks/useDescriptionFooters';
import { useFragmentForm } from './useFragmentForm';

export function DescriptionFooterSelector() {
  const { watch, setValue } = useFragmentForm();
  const stationId = watch('stationId');
  const description = watch('description') || '';
  const footers = useDescriptionFooters(stationId);

  function setFooter(content: string) {
    setValue('description', description + content);
  }

  if (!footers.length) {
    return null;
  }

  return (
    <Box display={'flex'}>
      <FormattedMessage id="fragments.form.useFooter" defaultMessage="Usar footer:" />
      <Box display={'flex'} gap={1} ml={1}>
        {footers.map((f, index) => (
          <Box key={f.name}>
            <a
              href={'#'}
              onClick={(event) => {
                event.preventDefault();
                setFooter(f.content);
              }}
            >
              {f.name}
            </a>
            {index !== footers.length - 1 && <>&nbsp;&nbsp;/</>}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
